enum GoalSurveyType {
	BeProductive = 0,
	IncreaseSelfEsteemAssessment = 1,
	ImproveSleep = 2,
	ReduceStress = 3,
	PerformBreathingTechniques = 4,
	TuneInToThePositive = 5
}
export default GoalSurveyType
